const API_ENDPOINTS = {
  USER_VALIDATE_TOKEN: "admin/validate-token",
  USER_LOGIN: "admin/login",
  USER_UPDATE_PROFILE: "admin/update-profile",
  USER_UPDATE_PASSWORD: "admin/update-password",

  USER_DETAIL: 'user/detail/',
  USER_SAVE: 'user/save',
  USER_TOGGLE_STATUS: 'user/update-status',
  USER_UPDATE_VERFICATIONS: 'user/update-selfie-verification-status',

  RESTAURANT_DETAIL: 'restaurant/detail/',
  RESTAURANT_FULL_DETAIL: 'restaurant/detail/',
  RESTAURANT_GENERATE_CODE: 'restaurant/generate-restaurant-id/',
  RESTAURANT_DELETE: 'restaurant/delete',
  RESTAURANT_TOGGLE_STATUS: 'restaurant/toggle/status',
  RESTAURANT_UPDATE_VERFICATIONS: 'restaurant/update-selfie-verification-status',
  
  //FILE ROUTES
  FILE_UPLOAD: "file/save",
  FILE_REMOVE: "file/remove",

  //Various Routes
  VARIOUS_APPLICATION_DETAIL: "various/application/",
  VARIOUS_APPLICATION_LIST: "various/application/list",
  VARIOUS_APPLICATION_SAVE: "various/application/save",

  VARIOUS_SETTING_DETAIL: "various/setting/",
  VARIOUS_SETTING_LIST: "various/setting/list",
  VARIOUS_SETTING_SAVE: "various/setting/save",

  DASHBOARD_LIST: "/dashboard/data",
  
  CATEGORY_DETAIL: "category/",
  CATEGORY_LIST: "category/list",
  CATEGORY_SAVE: "category/save",
  CATEGORY_DELETE: "category/delete",
  CATEGORY_TOGGLE_STATUS: "category/toggle-status",
  
  LEDGER_LIST: "ledger/list",
  UNSETTLED_PAYOUTS: "ledger/list-uncleared-settlement",
  LEDGER_SAVE: "ledger/save",
  LEDGER_DELETE: "ledger/delete",
  
  FOOD_TEMPLATE_SAVE: "food-template/save",
  FOOD_TEMPLATE_LIST: "food-template/list",
  FOOD_TEMPLATE_DELETE: "food-template/delete",
  
  ADDRESS_SAVE: "address/save",
  ADDRESS_LIST: "address/list",
  ADDRESS_DELETE: "address/delete",

  ADMIN_SETTING_LIST: '/restaurant-setting/list',
  ADMIN_SETTING_SAVE: '/restaurant-setting/save',

  SUBSCRIPTION_PLAN_SAVE: 'subscription-plan/save',
  SUBSCRIPTION_PLAN_LIST: 'subscription-plan/list',
  SUBSCRIPTION_PLAN_DELETE: 'subscription-plan/delete',
  

  // new endpoints arruk onap
  RESTAURANT_LIST: 'restaurant/list',
  RESTAURANT_SAVE: 'restaurant/create',
  
  // new endpoints arruk onap
  USER_LIST: 'user/list',

  // blog management
  BLOG_LIST: 'blog/list',
  BLOG_SAVE: 'blog/save',
  BLOG_TOGGLE_PUBLISHED: 'blog/toggle-published',
  BLOG_DELETE: 'blog/delete',

  // restaurant menu management (admin)
  RESTAURANT_MENU_CATEGORY_LIST: 'menu/category/list',
  RESTAURANT_MENU_CATEGORY_SAVE: 'menu/category/create-update',
  RESTAURANT_MENU_ITEM_LIST: 'menu/item/list',
  RESTAURANT_MENU_ITEM_SAVE: 'menu/item/save',
  RESTAURANT_MENU_ITEM_DELETE: 'menu/item/delete',















};

export default API_ENDPOINTS;
